module.exports = __webpack_public_path__ + "img/footer_logo.bb3c350c.png";